<template>
  <a
    :href="link"
    :target="target"
    class="social-share-link"
    :class="{'social-share-link--submission-share': submissionShare}"
  >
    <span class="social-share-link__icon" v-if="iconName === 'facebook'">
      <svg viewBox="0 0 10 18" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 7h2V3l1-1a3 3 0 0 1 2-1 21 21 0 0 1 3 0v2H8v1H6v3h3v3H6v8H3v-8H1V7z"
          fill-rule="evenodd"
        />
      </svg>
    </span>
    <span class="social-share-link__icon" v-if="iconName === 'twitter'">
      <svg viewBox="0 0 17 14" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 2a8 8 0 0 1-2 0 3 3 0 0 0 2-2 7 7 0 0 1-3 1 3 3 0 0 0-2-1L9 1a3 3
              0 0 0-1 3 10 10 0 0 1-7-3 4 4 0 0 0 0 3l1 1H1l1 2 1 1a3 3 0 0 1-1 1V8a4
              4 0 0 0 3 3 7 7 0 0 1-4 1 8 8 0 0 1-1 0 10 10 0 0 0 5 2 9 9 0 0 0 8-3 10
              10 0 0 0 2-7V3h1l1-1z" fill-rule="evenodd"/>
      </svg>
    </span>
    <span class="social-share-link__icon" v-if="iconName === 'instagram'">
      <svg viewBox="0 0 19 18" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.2 0H4.97A4.94 4.94 0 0 0 0 4.9v8.2a4.75 4.75 0 0 0 1.45 3.45A5.13
                 5.13 0 0 0 4.95 18h8.26a5.13 5.13 0 0 0 3.5-1.45 4.81 4.81 0 0 0
                 1.46-3.46V4.91A4.92 4.92 0 0 0 13.2 0zm3.32 13.1c0 .89-.32 1.65-.97
                 2.3a3.2 3.2 0 0 1-2.34.95H4.96a3.2 3.2 0 0 1-2.35-.96 3.12 3.12 0 0
                 1-.96-2.3V4.91c0-.9.32-1.67.96-2.31a3.2 3.2 0 0 1 2.35-.97h8.25c.92 0
                 1.7.32 2.34.97.65.64.97 1.41.97 2.3v8.2zM9.74 4.9a3.39 3.39 0 0 0-1.24
                 0 3.8 3.8 0 0 0-1.53.56 4.23 4.23 0 0 0-1.84 2.5 3.97 3.97 0 0 0 .45
                 3.11 4.17 4.17 0 0 0 2.28 1.8 3.7 3.7 0 0 0 1.6.21c.11 0 .2-.03.28-.08a4.04
                 4.04 0 0 0 2.73-1.63 3.89 3.89 0 0 0 .74-3.03A4.02 4.02 0 0 0 9.74 4.9zm1.42
                 5.49c-.21.24-.46.46-.74.64-.28.19-.6.3-.93.34a2.59 2.59 0 0 1-1.83-.47 2.22
                 2.22 0 0 1-.98-1.58c-.11-.66.04-1.26.46-1.82.42-.55.96-.87 1.61-.96h.66a2.48
                 2.48 0 0 1 2.08 2.05c.07.33.08.65 0 .97-.07.3-.18.59-.33.83zm1.9-6.46a.69.69
                 0 0 0-.2.25.82.82 0 0 0-.06.32c0
                 .12.02.22.06.31.04.1.1.18.2.27.07.08.17.13.27.17.11.04.21.06.3.06.12 0
                 .22-.02.31-.06.1-.04.19-.1.28-.17a.93.93 0 0 0 .17-.3.82.82 0 0 0 0-.6.8.8
                 0 0 0-.17-.25.8.8 0 0 0-1.17 0z" fill-rule="evenodd"/>
      </svg>
    </span>
  </a>
</template>

<script>

export default {
  name: 'social-share-button',
  props: {
    iconName: { type: String, require: true }, // one of facebook, twitter, or instagram;
    submissionShare: { type: Boolean, default: false },
    link: { type: String, required: true }, // where this link should go.
    target: { type: String, default: '_blank' }
  }
};
</script>

<style lang="scss">
.social-share-link {
  display: block;
  justify-content: center;
  align-items: center;
  width: 2.8rem;
  height: 2.8rem;
  &__icon {
    display: block;
    position: relative;
    height: 100%;
    width: 100%;
    transition: transform 300ms ease;

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 50%;
      width: 50%;
      fill: $color-base-white-base;
    }
  }
  &:hover {
    .social-share-link {
      &__icon {
        transform: scale(1.4);
      }
    }
  }
  &--submission-share {
    margin: 0 0 0 $size-margin-submission-share-button-left-right / 2;
    background-color: $color-background-submission-share-button-base;
    transition: background-color 250ms ease;
    border-radius: 50%;
    &:hover {
      background-color: $color-background-submission-share-button-hover;
    }
  }
}
</style>
